module.exports = __webpack_public_path__ + "img/about-ch2-problems-inequality.4c7680eb.png";